__turbopack_context__.v({
  "activePage": "SecurityAdvisories-module-scss-module__WINVEG__activePage",
  "advisoryTile": "SecurityAdvisories-module-scss-module__WINVEG__advisoryTile",
  "calendarIcon": "SecurityAdvisories-module-scss-module__WINVEG__calendarIcon",
  "container": "SecurityAdvisories-module-scss-module__WINVEG__container",
  "dateBox": "SecurityAdvisories-module-scss-module__WINVEG__dateBox",
  "ellipsis": "SecurityAdvisories-module-scss-module__WINVEG__ellipsis",
  "headerTitle": "SecurityAdvisories-module-scss-module__WINVEG__headerTitle",
  "nextPage": "SecurityAdvisories-module-scss-module__WINVEG__nextPage",
  "pageButton": "SecurityAdvisories-module-scss-module__WINVEG__pageButton",
  "pageNumber": "SecurityAdvisories-module-scss-module__WINVEG__pageNumber",
  "pageWrapper": "SecurityAdvisories-module-scss-module__WINVEG__pageWrapper",
  "pagination": "SecurityAdvisories-module-scss-module__WINVEG__pagination",
  "prevPage": "SecurityAdvisories-module-scss-module__WINVEG__prevPage",
  "searchContainer": "SecurityAdvisories-module-scss-module__WINVEG__searchContainer",
  "tileLink": "SecurityAdvisories-module-scss-module__WINVEG__tileLink",
  "tileSummary": "SecurityAdvisories-module-scss-module__WINVEG__tileSummary",
  "tileTitle": "SecurityAdvisories-module-scss-module__WINVEG__tileTitle",
  "tilesGrid": "SecurityAdvisories-module-scss-module__WINVEG__tilesGrid",
});
